import type { ExternalCommit } from '../../types';

export const isExternalCommit = (entity: any): entity is ExternalCommit =>
	entity.__typename === 'ExternalCommit';

export const getExternalCommitLink = (commit: ExternalCommit): string | null => commit?.url ?? null;
